import { AutoPlay } from '@egjs/flicking-plugins';
import Flicking, { Plugin } from '@egjs/react-flicking';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import styles from './Intro.module.scss';

const cx = classNames.bind(styles);

interface IFlickingContent {
  title: String;
  subtitle: String;
  url?: string;
  nClickCode?: string;
}

const Intro = ({ items }: { items: IFlickingContent[] }) => {
  const [curPage, setCurPage] = useState(0);
  const plugins: Plugin[] = [
    new AutoPlay({ duration: 4000, stopOnHover: true }) as unknown as Plugin,
  ];

  const onFlickerClick = (item: IFlickingContent) => (e: any) => {
    if (item?.url && item?.nClickCode) {
      e.preventDefault();
      window.open(item.url);
    }
  };

  // Updating Activation of Flicking Dots
  const setDotActive = () => {
    const flickerDots = document.querySelectorAll('._flickerDot');
    if (flickerDots) {
      Array.from(flickerDots).forEach((dot, index) => {
        dot.setAttribute('aria-selected', String(index === curPage));
      });
    }
  };

  useEffect(() => {
    setDotActive();
  }, [curPage]);

  return (
    <div className={cx('Intro')}>
      <div className={cx('spot')}>
        <div className={cx('bg')} />
        <div className={cx('obj1', 'obj1_global')} />
        <div className={cx('obj2')} />
      </div>
      <div className={cx('flick')}>
        <Flicking
          className={cx('flicker')}
          align="prev"
          circular
          plugins={plugins}
          onChanged={e => setCurPage(e.index)}
          preventDefaultOnDrag
        >
          {items.map((item, index) => {
            return item.url ? (
              <a
                className={cx('panel')}
                href={item.url}
                key={index}
                data-event-nlog="click"
                data-event-area-code={item.nClickCode}
                onClick={onFlickerClick(item)}
              >
                <b className={cx('tit')}>{item.title}</b>
                <i className={cx('sub')}>{item.subtitle}</i>
              </a>
            ) : (
              <div className={cx('panel')} key={index}>
                <b className={cx('tit')}>{item.title}</b>
                <i className={cx('sub')}>{item.subtitle}</i>
              </div>
            );
          })}
        </Flicking>
        {items.length > 1 && (
          <div className={cx('indicator')}>
            {items.map((item, index) => (
              <button
                type="button"
                className={cx('dot', '_flickerDot')}
                aria-current={index === curPage}
                key={index}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Intro;
